<template>
  <v-img
    v-if="url"
    class="bg-transparent"
    :width="width"
    :max-width="maxWidth"
    :height="height"
    :src="url"
    :alt="url"
    :contain="contain"
    aspect-ratio="1"
    v-on="$listeners"
    @error="getFallback()">
    <template v-slot:placeholder>
      <v-row
        class="fill-height ma-0"
        align="center"
        justify="center">
        <v-progress-circular
          color="primary"
          size="14"
          width="1"
          indeterminate />
      </v-row>
    </template>
  </v-img>
</template>

<script>

import imgEmpty from '@/assets/img/product-placeholder.png'

export default {
  props: {
    src: {
      type: String,
      default: ''
    },
    maxWidth: {
      type: [String, Number],
      default: undefined
    },
    width: {
      type: [String, Number],
      default: '100'
    },
    height: {
      type: [String, Number],
      default: '100'
    },
    contain: Boolean
  },
  data () {
    return {
      url: null
    }
  },
  watch: {
    src: {
      immediate: true,
      handler (newValue) {
        this.url = newValue || imgEmpty
      }
    }
  },
  methods: {
    getFallback () {
      this.url = imgEmpty
    }
  }
}
</script>
